export default __webpack_public_path__ + "static/media/settingsFilled.4abf347b.svg";